// Text-only display alternatives for a self-guided Journey. This helper
// never changes the authored answer key, saved fields, completion rules,
// activity order, or teacher-led presentation.
const selfGuidedFields = {
  prompt: "self_guided_prompt",
  placeholder: "self_guided_placeholder",
  incorrect_feedback: "self_guided_incorrect_feedback",
  retry_feedback: "self_guided_retry_feedback",
  complete_prompt: "self_guided_complete_prompt",
  complete_title: "self_guided_complete_title",
  suggested_questions: "self_guided_suggested_questions",
  reveal_policy: "self_guided_reveal_policy",
};

export const applySelfGuidedTeachingCopy = (block) => {
  if (!block || typeof block !== "object") return block;
  const copy = { ...block };
  Object.entries(selfGuidedFields).forEach(([displayField, overrideField]) => {
    if (block[overrideField] != null) copy[displayField] = block[overrideField];
  });
  // A gallery caption can accidentally pre-answer a later evidence question.
  // Keep the full authored caption in teacher-led mode and use the observational
  // alternative only while the child is investigating independently.
  if (Array.isArray(block.images)) {
    copy.images = block.images.map((image) => image?.self_guided_caption != null
      ? { ...image, caption: image.self_guided_caption }
      : image);
  }
  return copy;
};
